import React from 'react';

import Button from '@/common/components/atoms/Button/Button';
import {
  DisabledButtonDefaultProps,
  DisabledButtonPropTypes,
} from '@/ebat/components/blocks/Header/CartButton/DisabledCartButton/DisabledCartButton.proptypes';

const DisabledCartButton = ({ className, children }) => (
  <Button className={className} context="header-add-to-cart" disabled>
    {children}
  </Button>
);

DisabledCartButton.defaultProps = {
  ...DisabledButtonDefaultProps,
};

DisabledCartButton.propTypes = {
  ...DisabledButtonPropTypes,
};

export default DisabledCartButton;
